<template>
    <v-dialog v-model="show" max-width="1200" min-width="1200" width="1200" height="700" scrollable>
        <v-card style="height: 700px; max-height: 90vh; display: flex; flex-direction: column;">
            <v-card-title class="text-h5" style="flex-shrink: 0;">
                <div class="d-flex justify-space-between align-center" style="width: 100%;">
                    <div>
                        Productos y servicios disponibles
                    </div>
                    <v-btn @click.stop="show = false" class="btndisable">
                        Continuar
                    </v-btn>
                </div>
            </v-card-title>
            
            <v-card-text style="flex: 1; display: flex; flex-direction: column; overflow: hidden;">
                <div class="d-flex justify-space-between mt-4" style="flex-shrink: 0;">
                    <div style="margin-top: auto; margin-bottom: auto;">
                        <div>
                            <v-btn @click="goToPreviousPage" v-if="!familiesPage" style="border-radius: 800px !important; height: 60px;"><v-icon>mdi-arrow-left</v-icon></v-btn>
                            <label v-if="showElements" class="ml-8" style="font-size: 20px; font-weight: bold;">Seleccione un producto o servicio</label>
                            <label v-else class="ml-8" style="font-size: 20px; font-weight: bold;">Seleccione una {{ currentLabel }}</label>
                        </div>
                        <div class="ml-8" v-if="currentFamilyLabel">
                            <label>Filtro actual:</label><br/>
                            <label v-if="currentFamilyLabel"><strong>Familia</strong>:{{ currentFamilyLabel }}</label><label v-if="currentCategoryLabel">, <strong>Categoría</strong>: {{ currentCategoryLabel }}</label><label v-if="currentSubCategoryLabel">, <strong>SubCategoría</strong>: {{ currentSubCategoryLabel }}</label>
                        </div>
                    </div>
                    <div>
                        <v-switch :label="`Ver productos y servicios disponibles`" v-model="showElements"></v-switch>
                        <div v-if="showElements" class="d-flex justify-center">
                            <v-radio-group v-model="elementsToShow" row >
                                <v-radio :label="`Todos (${allElementsToShow.length})`" :value="0"></v-radio>
                                <v-radio :label="`Productos (${productsToShow.length})`" :value="1"></v-radio>
                                <v-radio :label="`Servicios (${servicesToShow.length})`" :value="2"></v-radio>
                            </v-radio-group>
                        </div>
                    </div>
                </div>
                <div v-if="!displayElements" style="flex: 1; overflow-y: auto; padding: 16px 0;">
                    <v-row v-if="familiesPage" class="py-3" no-gutters>
                        <v-col 
                            v-for="(item, index) in families" :key="index" class="px-1 py-1"
                            cols="12" 
                            sm="6" 
                            md="4" 
                            lg="3" 
                        >
                            <div 
                                class="grid-card d-flex flex-column align-center justify-center px-2 py-1 text-center"
                                @click="clickFamily( item.id, categoriesPerFamily(item['id']) )"
                                style="min-height: 64px;"
                                :style="{
                                    backgroundColor: getProductColor(`${item.id}`).main,
                                    color: getProductColor(`${item.id}`).contrast,
                                }"
                            >
                                <div class="font-weight-bold mb-1">
                                     {{item["name"]}}
                                </div>
                                <!-- <div style="font-size: 0.9em;">
                                    Servicios y Productos Disponibles: {{ familyCount(item["id"]) }}
                                </div>
                                <div style="font-size: 0.9em;">
                                    Categorías Disponibles: {{ categoriesPerFamily(item["id"]) }}
                                </div> -->
                            </div>
                        </v-col>
                    </v-row>
                    <v-row v-if="categoriesPage" class="py-3" no-gutters>
                        <v-col 
                            v-for="(item, index) in categoriesByFamily" 
                            cols="12" 
                            sm="6" 
                            md="4" 
                            lg="3" 
                            :key="index" 
                            class="px-1 py-1"
                        >
                            <div 
                                class="grid-card d-flex flex-column align-center justify-center px-2 py-1 text-center"   
                                @click="clickCategory( item.id, subcategoriesPerCategory( item[ 'id' ] ))"
                                style="min-height: 64px;"
                                :style="{
                                    backgroundColor: getProductColor(`${item.id}`).main,
                                    color: getProductColor(`${item.id}`).contrast,
                                }"
                            >
                                <div class="font-weight-bold mb-1">
                                     {{item["name"]}}
                                </div>
                                <!-- <div style="font-size: 0.9em;">
                                    Servicios y Productos Disponibles: {{ categoryCount(item["id"]) }}
                                </div>
                                <div style="font-size: 0.9em;">
                                    Subcategorías Disponibles: {{ subcategoriesPerCategory(item["id"]) }}
                                </div> -->
                            </div>
                        </v-col>
                    </v-row>
                    <v-row v-if="subCategoriesPage" class="py-3" no-gutters>
                        <v-col 
                            v-for="(item, index) in subcategoriesByCategory"
                            cols="12" 
                            sm="6" 
                            md="4" 
                            lg="3" 
                            :key="index" 
                            class="px-1 py-1"
                        >
                            <div 
                                class="grid-card d-flex flex-column align-center justify-center px-2 py-1 text-center"    
                                @click="clickSubCategory( item.id )"
                                style="min-height: 64px;"
                                :style="{
                                    backgroundColor: getProductColor(`${item.id}`).main,
                                    color: getProductColor(`${item.id}`).contrast,
                                }"
                            >
                                <div class="font-weight-bold mb-1">
                                     {{item["name"]}}
                                </div>
                                <!-- <div style="font-size: 0.9em;">
                                    Servicios y Productos Disponibles: {{ subcategoryCount(item["id"]) }}
                                </div> -->
                            </div>
                        </v-col>
                    </v-row>
                </div>
                <div v-else style="flex: 1; overflow-y: auto; padding: 16px 0;">
                    <v-row v-if="displayAll" class="py-3" no-gutters>
                        <v-col 
                            v-for="(item, index) in allElementsToShow" 
                            :key="index" 
                            :id="`all${item.type}${item.id}`"
                            cols="12" 
                            :sm="item.active ? 6 : 6" 
                            :md="item.active ? 8 : 4" 
                            :lg="item.active ? 9 : 3" 
                            class="px-2 py-2"
                        >
                            <div 
                                class="grid-card d-flex flex-column align-center justify-center px-2 py-1 text-center"  
                                style="min-height: 64px;"
                                :style="{
                                    backgroundColor: getProductColor(item.id).main,
                                    color: getProductColor(item.id).contrast,
                                }"
                               @click="activateCurrentItem(index, item)"
                            >
                                <div class="font-weight-bold mb-1">
                                     {{item["name"]}}
                                </div>
                                <div style="font-size: 0.8em;" class="mt-1">
                                    <span v-if="item.data.ItemNewPrice">${{ (item.data.ItemNewPrice).toFixed(2) }}</span>
                                </div>
                            </div>
                            <v-expand-transition>
                                <div v-if="item.active" class="quantityManagement">
                                    <div class="closeQuantityManagementPanel">
                                        <v-icon class="rightAllignedArrow" @click="() => {
                                            cancelQuantityManagement(index)
                                        }" large>
                                            mdi-menu-up
                                        </v-icon>
                                    </div>
                                    <div>
                                        <v-icon class="buttonIcon" x-large color="white" @click="() => {
                                            increaseQty( index )
                                        }">mdi-menu-up</v-icon>
                                        <input
                                            :id="`tableinputnumber${item.type}${item.id}`"
                                            class="tableinputnumber"
                                            v-model="item.cantidad"
                                            type="text"
                                            @input="e => {
                                                onKeyPressQuantity( e, index );
                                            }"
                                            label="Nivel"
                                        />
                                        <v-icon class="buttonIcon" x-large color="white" @click="() => {
                                            decreaseQty( index )
                                        }">mdi-menu-down</v-icon>
                                        <v-icon class="downPanelButtons" large color="white" @click="() => {
                                            sendElement( index )
                                        }">
                                            mdi-check
                                        </v-icon>
                                    </div>
                                    <div :id="`errorspan${item.type}${item.id}`" class="hideSpan divErrorSpan">
                                        <div class="errorSpan"></div>
                                    </div>
                                </div>
                            </v-expand-transition>
                        </v-col>
                    </v-row>
                    <v-row v-if="displayProducts" class="py-3" no-gutters >
                        <v-col 
                            v-for="(item, index) in productsToShow" 
                            :key="index" 
                            :id="`product${item.type}${item.id}`"
                            cols="12" 
                            :sm="item.active ? 6 : 6" 
                            :md="item.active ? 8 : 4" 
                            :lg="item.active ? 9 : 3" 
                            class="px-2 py-2"
                        >
                            <div 
                                class="grid-card d-flex flex-column align-center justify-center px-2 py-1 text-center"  
                                style="min-height: 64px;"
                                :style="{
                                    backgroundColor: getProductColor(item.id).main,
                                    color: getProductColor(item.id).contrast,
                                }"
                               @click="activateCurrentItem(index, item)"
                            >
                                <div class="font-weight-bold mb-1">
                                     {{item["name"]}}
                                </div>
                            </div>
                            <v-expand-transition>
                                <div v-if="item.active" class="quantityManagement">
                                    <div class="closeQuantityManagementPanel">
                                        <v-icon class="rightAllignedArrow" @click="() => {
                                            cancelQuantityManagement(index)
                                        }" large>
                                            mdi-menu-up
                                        </v-icon>
                                    </div>
                                    <div>
                                        <!-- <v-btn class="leftSideDownPanelButton downPanelButtons btndelete" @click="() => {
                                            cancelQuantityManagement(index)
                                        }">
                                            <v-icon>
                                                mdi-cancel
                                            </v-icon>
                                        </v-btn> -->
                                        <v-icon class="buttonIcon" x-large color="white" @click="() => {
                                            increaseQty( index )
                                        }">mdi-menu-up</v-icon>
                                        <input
                                            :id="`tableinputnumber${item.type}${item.id}`"
                                            class="tableinputnumber"
                                            v-model="item.cantidad"
                                            type="text"
                                            @input="e => {
                                                onKeyPressQuantity( e, index );
                                            }"
                                            label="Nivel"
                                        />
                                        <v-icon class="buttonIcon" x-large color="white" @click="() => {
                                            decreaseQty( index )
                                        }">mdi-menu-down</v-icon>
                                        <v-icon class="downPanelButtons" large color="white" @click="() => {
                                            sendElement( index )
                                        }">
                                            mdi-check
                                        </v-icon>
                                    </div>
                                    <div :id="`errorspan${item.type}${item.id}`" class="hideSpan divErrorSpan">
                                        <div class="errorSpan"></div>
                                    </div>
                                </div>
                            </v-expand-transition>
                        </v-col>
                    </v-row>
                    <v-row v-if="displayServices" class="py-3" no-gutters >
                        <v-col 
                            v-for="(item, index) in servicesToShow" 
                            :key="index" 
                            :id="`service${item.type}${item.id}`"
                            cols="12" 
                            :sm="item.active ? 6 : 6" 
                            :md="item.active ? 8 : 4" 
                            :lg="item.active ? 9 : 3" 
                            class="px-2 py-2"
                        >
                            <div 
                                class="grid-card d-flex flex-column align-center justify-center px-2 py-1 text-center"  
                                style="min-height: 64px;"
                                :style="{
                                    backgroundColor: getProductColor(item.id).main,
                                    color: getProductColor(item.id).contrast,
                                }"
                               @click="activateCurrentItem(index, item)"
                            >
                                <div class="font-weight-bold mb-1">
                                     {{item["name"]}}
                                </div>
                            </div>
                            <v-expand-transition>
                                <div v-if="item.active" class="quantityManagement">
                                    <div class="closeQuantityManagementPanel">
                                        <v-icon class="rightAllignedArrow" @click="() => {
                                            cancelQuantityManagement(index)
                                        }" large>
                                            mdi-menu-up
                                        </v-icon>
                                    </div>
                                    <div>
                                        <!-- <v-btn class="leftSideDownPanelButton downPanelButtons btndelete" @click="() => {
                                            cancelQuantityManagement(index)
                                        }">
                                            <v-icon>
                                                mdi-cancel
                                            </v-icon>
                                        </v-btn> -->
                                        <v-icon class="buttonIcon" x-large color="white" @click="() => {
                                            increaseQty( index )
                                        }">mdi-menu-up</v-icon>
                                        <input
                                            :id="`tableinputnumber${item.type}${item.id}`"
                                            class="tableinputnumber"
                                            v-model="item.cantidad"
                                            type="text"
                                            @input="e => {
                                                onKeyPressQuantity( e, index );
                                            }"
                                            label="Nivel"
                                        />
                                        <v-icon class="buttonIcon" x-large color="white" @click="() => {
                                            decreaseQty( index )
                                        }">mdi-menu-down</v-icon>
                                        <v-icon class="downPanelButtons" large color="white" @click="() => {
                                            sendElement( index )
                                        }">
                                            mdi-check
                                        </v-icon>
                                    </div>
                                    <div :id="`errorspan${item.type}${item.id}`" class="hideSpan divErrorSpan">
                                        <div class="errorSpan"></div>
                                    </div>
                                </div>
                            </v-expand-transition>
                        </v-col>
                    </v-row>
                </div>
                <!-- <div style="display: flex; margin-left: 5px">
                    <input type="radio" id="InvoiceProductBtn" value="products" v-model="displayInvoice" />
                    <h5 style="margin: 5px" for="InvoiceProductBtn">Productos</h5>
                    <input style="margin-top: 1px; margin-left: 10px" type="radio" id="InvoiceServiceBtn" value="services"
                    v-model="displayInvoice" />
                    <h5 style="margin: 5px" for="InvoiceServiceBtn">Servicios</h5>
                </div>
                <template v-if="displayInvoice === 'products'">
                    
                </template>
                <template v-else-if="displayInvoice === 'services'">
                    
                </template> -->
            </v-card-text>
            <!-- <v-card-actions style="flex-shrink: 0; justify-content: flex-end; padding: 16px;">
              <v-btn @click.stop="show = false" class="btndisable">
                Continuar
              </v-btn>
            </v-card-actions> -->
        </v-card>
    </v-dialog>
</template>
<script>
import { onlyDigits } from "@/helpers/masks";
import { pickColorPairById } from "./ProductColorPicker";

export default {
    name: 'InvoiceProductsClasificationSelector',
    components: {
    
    },
    emits: [ "close" ],
    props: [
        "value",
        "products",
        "services"
    ],
    data() {
        return {
            displayInvoice: 'services',
            families: [],
            categories: [],
            subcategories: [],
            categoriesByFamily: [],
            subcategoriesByCategory: [],
            familiesPage: true,
            categoriesPage: false,
            subCategoriesPage: false,
            showElements: false,
            elementsToShow: 0, // 0 = Todos, 1 = Productos, 2 = Servicios
            hasDetails: true,
            currentFilter: {
                family: null,
                category: null,
                subcategory: null
            },
            productsMapFilter: {
                family: "IdFamily",
                category: "IdCategory",
                subcategory: "IdSubCategory"
            },
            productsToShow: [],
            servicesToShow: [],
            allElementsToShow: [],
        }
    },
    computed: {
        currentFamilyLabel(){
            return this.families.find( current => {
                const { id } = current
                return id === this.currentFilter.family
            } )?.name;
        },
        currentCategoryLabel(){
            return this.categories.find( current => {
                const { id } = current
                return id === this.currentFilter.category
            } )?.name;
        },
        currentSubCategoryLabel(){
            return this.subcategories.find( current => {
                const { id } = current
                return id === this.currentFilter.subcategory
            } )?.name;
        },
        selectedElementsToShow() {
            if (this.displayAll) {
                return this.allElementsToShow;
            } else if (this.displayServices) {
                return this.servicesToShow;
            } else {
                return this.productsToShow;
            }
        },
        show: {
            get () {
                return this.value
            },
            set (value) {
                this.$emit('input', value)
            }
        },
        totalProducts() {
            return this.products.filter( current => current.IdFamily != null )
        },
        totalServices() {
            return this.services.filter( current => current.family != null )
        },
        currentLabel(){
            if( this.familiesPage ) {
                return "familia";
            } else if( this.categoriesPage) {
                return "categoría";
            } else {
                return "subcategoría";
            }
        },
        displayElements() {
            if( this.showElements ) {
                return true;
            }

            return false;
        },
        displayProducts() {
            return this.showElements && this.elementsToShow === 1;
        },
        displayServices() {
            return this.showElements && this.elementsToShow === 2;
        },
        displayAll() {
            return this.showElements && this.elementsToShow === 0;
        },
    },
    watch: {
        hasDetails(value) {
            if( !value ) {
                this.showElements = true;
            } else {
                this.showElements = false;
            }
        },
        products() {
            this.productsToShow = this.returnProductsWithCurrentFilter();
            this.updateAllElementsToShow();
        },
        services() {
            this.servicesToShow = this.returnServicesWithCurrentFilter();
            this.updateAllElementsToShow();
        }
    },
    async mounted() {
        await this.getAllInfo();
        this.loadElements();
    },
    methods: {
        loadElements() {
            this.productsToShow = this.returnProductsWithCurrentFilter();
            this.servicesToShow = this.returnServicesWithCurrentFilter();
            this.updateAllElementsToShow();
        },
        updateAllElementsToShow() {
            // Combinar productos y servicios en un solo array
            this.allElementsToShow = [...this.productsToShow, ...this.servicesToShow];
        },
        getProductColor(id) {
            const colors = pickColorPairById(id);
            return colors
        },  
        returnProductsWithCurrentFilter() {
            const filteredProducts = this.products.filter( current => {
                let returnValue = false;
                for( const property in this.currentFilter ) {
                    if( this.currentFilter[ property ] ) {
                        if( !returnValue ) {
                            returnValue = current[ this.productsMapFilter[ property ] ] === this.currentFilter[ property ];
                        } else {
                            returnValue = returnValue && current[ this.productsMapFilter[ property ] ] === this.currentFilter[ property ];
                        }
                    }
                }
                return returnValue;
            } );

            // Ordenar productos por orderItem
            const sortedProducts = filteredProducts.sort( this.sortByOrderItem );

            const productsArray =
                this.currentFilter.family ?
                    sortedProducts.map( current => {
                        const { ID_Item, ItemName, ItemCurrentQuantity, ItemMeasureUnit, ItemLote, NameWarehouse } = current;

                        return {
                            type: 1,
                            id: ID_Item,
                            name: ItemName,
                            cantidad: 0,
                            stocks: `${ItemCurrentQuantity} ${ItemMeasureUnit}`,
                            batch: ItemLote,
                            warehouse: NameWarehouse,
                            hasError: false,
                            active: false,
                            data: {...current}
                        };
                    } ) :
                    this.totalProducts.sort( this.sortByOrderItem ).map( current => {
                        const { ID_Item, ItemName, ItemCurrentQuantity, ItemMeasureUnit, ItemLote, NameWarehouse } = current;
                        
                        return {
                            type: 1,
                            id: ID_Item,
                            name: ItemName,
                            cantidad: 0,
                            stocks: `${ItemCurrentQuantity} ${ItemMeasureUnit}`,
                            batch: ItemLote,
                            warehouse: NameWarehouse,
                            hasError: false,
                            active: false,
                            data: {...current}
                        };
                    } );

            return productsArray;
        },
        returnServicesWithCurrentFilter() {
            const filteredServices = this.services.filter( current => {
                let returnValue = false;
                for( const property in this.currentFilter ) {
                    if( this.currentFilter[ property ] ) {
                        if( !returnValue ) {
                            returnValue = current[ property ] === this.currentFilter[ property ];
                        } else {
                            returnValue = returnValue && current[ property ] === this.currentFilter[ property ];
                        }
                    }
                }

                return returnValue;
            } );

            // Ordenar servicios por orderItem
            const sortedServices = filteredServices.sort( this.sortByOrderItem );

            const servicesArray = 
                this.currentFilter.family ?
                    sortedServices.map( current => {
                        const { CodeService, NameService } = current;

                        return {
                            type: 2,
                            id: CodeService,
                            name: NameService,
                            cantidad: 0,
                            hasError: false,
                            active: false,
                            data: {...current}
                        };
                    } ) :
                    this.totalServices.sort( this.sortByOrderItem ).map( current => {
                        const { CodeService, NameService } = current;

                        return {
                            type: 2,
                            id: CodeService,
                            name: NameService,
                            cantidad: 0,
                            hasError: false,
                            active: false,
                            data: {...current}
                        };
                    } );

            return servicesArray;
        },
        activateCurrentItem(index) {
            for(const i in this.selectedElementsToShow) {
                if( this.selectedElementsToShow[ i ].active ) {
                    this.cancelQuantityManagement( i );
                }
            }
            
            this.selectedElementsToShow[ index ].active = true;
        },
        cancelQuantityManagement( index ) {
            const refItem = this.selectedElementsToShow[ index ];
            const { type, id } = refItem;
            const target = document.getElementById( `tableinputnumber${type}${id}` );

            [...target.classList].includes( 'erroredtableinputnumber' ) && target.classList.remove( 'erroredtableinputnumber' );

            refItem.cantidad = 0;
            refItem.hasError = false;
            refItem.active = false;
        },
        async onKeyPressQuantity(e, index){
            const refItem = this.selectedElementsToShow[ index ];
            const { data: { ItemCurrentQuantity }, type, id } = refItem;
            const errorSpan = document.getElementById(  `errorspan${type}${id}` );

            // console.log(errorSpan.classList);
            ![...errorSpan.classList].includes( 'hideSpan' ) && errorSpan.classList.add( 'hideSpan' );
            refItem.error = '';

            // console.log('refItem ', refItem);
            
            e.target.value = await onlyDigits( this, e.target.value);
            
            const { target } = e;
            const { value } = target;

            if( value.length > 0 ) {
                const numberValue = parseInt( value );
                if( numberValue > ItemCurrentQuantity ) {
                    errorSpan.classList.remove( 'hideSpan' );
                    target.classList.add( 'erroredtableinputnumber' );
                    errorSpan.children[0].innerHTML = 'La cantidad ingresada no puede ser mayor a las existencias del producto seleccionado'
                    refItem.hasError = true;
                    // console.log( refItem.hasError, refItem.error )
                } else if ( numberValue <= 0 ) {
                    errorSpan.classList.remove( 'hideSpan' );
                    target.classList.add( 'erroredtableinputnumber' );
                    errorSpan.children[0].innerHTML = 'La cantidad ingresada no puede ser menor o igual a 0'
                    refItem.hasError = true;
                } else {
                    refItem.hasError = false;
                    target.classList.remove( 'erroredtableinputnumber' );
                }
            } else {
                refItem.hasError = false;
                target.classList.remove( 'erroredtableinputnumber' );
            }
        },
        increaseQty(index) {
            this.selectedElementsToShow[ index ].cantidad = parseInt( this.selectedElementsToShow[ index ].cantidad ) + 1
            this.validateOutOfInput( index );
        },
        decreaseQty(index) {
            const decreaseResult = parseInt( this.selectedElementsToShow[ index ].cantidad ) - 1
            if( decreaseResult < 0 ) {
                this.selectedElementsToShow[ index ].cantidad = 0
            } else {
                this.selectedElementsToShow[ index ].cantidad = decreaseResult
            }
            this.validateOutOfInput( index );
        },
        validateOutOfInput(index){
            const refItem = this.selectedElementsToShow[ index ];
            const { data: { ItemCurrentQuantity }, type, id, cantidad } = refItem;
            const errorSpan = document.getElementById(  `errorspan${type}${id}` );
            const target = document.getElementById( `tableinputnumber${type}${id}` )

            // console.log(errorSpan.classList);
            ![...errorSpan.classList].includes( 'hideSpan' ) && errorSpan.classList.add( 'hideSpan' );
            refItem.error = '';

            // console.log('refItem ', refItem);
            const numberValue = parseInt( cantidad );

            if( numberValue > ItemCurrentQuantity ) {
                errorSpan.classList.remove( 'hideSpan' );
                target.classList.add( 'erroredtableinputnumber' );
                errorSpan.children[0].innerHTML = 'La cantidad ingresada no puede ser mayor a las existencias del producto seleccionado'
                refItem.hasError = true;
                target.focus();
                // console.log( refItem.hasError, refItem.error )
            } else if ( numberValue <= 0 ) {
                errorSpan.classList.remove( 'hideSpan' );
                target.classList.add( 'erroredtableinputnumber' );
                errorSpan.children[0].innerHTML = 'La cantidad ingresada no puede ser menor o igual a 0'
                refItem.hasError = true;
                target.focus();
            } else {
                refItem.hasError = false;
                target.classList.remove( 'erroredtableinputnumber' );
            }
        },
        lostFocus(index){
            const refItem = this.selectedElementsToShow[ index ];
            const { type, id } = refItem;
            const errorSpan = document.getElementById(  `errorspan${type}${id}` );
            ![...errorSpan.classList].includes( 'hideSpan' ) && errorSpan.classList.add( 'hideSpan' );
        },
        focus(e, index){
            const refItem = this.selectedElementsToShow[ index ];
            const { data: { ItemCurrentQuantity }, type, id } = refItem;
            const { target: { value } } = e;
            const numberValue = parseInt( value );

            const errorSpan = document.getElementById(  `errorspan${type}${id}` );
            if( [...errorSpan.classList].includes( 'hideSpan' ) && ItemCurrentQuantity < numberValue){
                errorSpan.classList.remove( 'hideSpan' );
            } 
        },
        async getAllInfo() {
            await this.getFamilies();
            this.getCategories();
            this.getSubs();
        },
        sortFunction(a, b) {
            const nameA = a.name ? a.name.toLowerCase() : '';
            const nameB = b.name ? b.name.toLowerCase() : '';

            if (!nameA) {
                return 1;
            }

            if (!nameB) {
                return -1;
            }

            if( nameA > nameB ) {
                return 1;
            }
            if( nameA < nameB ) {
                return -1;
            }
            return 0;
        },
        sortByOrderItem(a, b) {
            // Primero ordenar por orderItem, luego por nombre si orderItem es null o igual
            const orderA = a.orderItem !== null && a.orderItem !== undefined ? a.orderItem : 999999;
            const orderB = b.orderItem !== null && b.orderItem !== undefined ? b.orderItem : 999999;

            if (orderA !== orderB) {
                return orderA - orderB;
            }

            // Si orderItem es igual o ambos son null, ordenar por nombre
            const nameA = a.name ? a.name.toLowerCase() : '';
            const nameB = b.name ? b.name.toLowerCase() : '';

            if (!nameA) {
                return 1;
            }

            if (!nameB) {
                return -1;
            }

            if( nameA > nameB ) {
                return 1;
            }
            if( nameA < nameB ) {
                return -1;
            }
            return 0;
        },
        async getFamilies() {
            try {
                const response = await this.$API.itemtypes.getFamiliesHistory({ unlimited: true });
                const sortedResponse = [ ...response.sort( this.sortByOrderItem ) ];
                this.families = [ ...sortedResponse ];
            } catch (error) {
                console.log( error );
            }
        },
        async getCategories() {
            try {
                const response = await this.$API.itemtypes.getCategoriesHistory({ unlimited: true });
                const sortedResponse = [ ...response.sort( this.sortByOrderItem ) ];
                this.categories = [ ...sortedResponse ];
            } catch (error) {
                console.log(error);
            }
        },
        async getSubs() {
            try {
                const response = await this.$API.itemtypes.getSubsHistory({ unlimited: true });
                const sortedResponse = [ ...response.sort( this.sortByOrderItem ) ];
                this.subcategories = [ ...sortedResponse];
            } catch (error) {
                console.log(error)  
            }
        },
        familyCount(id) {
            const productsLength = this.products.filter( ( {IdFamily} ) => {
                return IdFamily === id;
            } ).length

            const servicesLength = this.services.filter( ( {family} ) => {
                return family === id;
            } ).length

            return productsLength + servicesLength;
        },
        categoriesPerFamily(id) {
            return this.categories.filter( ( { id_family } ) => {
                // Convertir ambos valores a string para comparación consistente
                return String(id_family) === String(id);
            } ).length;
        },
        subcategoriesPerCategory(id) {
            return this.subcategories.filter( ( { id_cat } ) => {
                // Convertir ambos valores a string para comparación consistente
                return String(id_cat) === String(id);
            } ).length;
        },
        categoryCount(id) {
            const productsLength = this.products.filter( ( {IdCategory} ) => {
                return IdCategory === id;
            } ).length

            const servicesLength = this.services.filter( ( {category} ) => {
                return category === id;
            } ).length

            return productsLength + servicesLength;
        },
        subcategoryCount(id) {
            const productsLength = this.products.filter( ( {IdSubCategory} ) => {
                return IdSubCategory === id;
            } ).length

            const servicesLength = this.services.filter( ( {subcategory} ) => {
                return subcategory === id;
            } ).length

            return productsLength + servicesLength;
        },
        clickFamily(id, count) {
            const filteredCategories = [ ...this.categories.filter( ( { id_family } ) => {
                // Convertir ambos valores a string para comparación consistente
                const familyId = String(id_family);
                const selectedId = String(id);
                return familyId === selectedId;
            } ) ];
            
            this.categoriesByFamily = filteredCategories.sort( this.sortByOrderItem );

            this.currentFilter.family = id;
            this.cleanPageFlags();
            count > 0 ? this.hasDetails = true : this.hasDetails = false;
            this.categoriesPage = true;
            this.loadElements();
        },
        clickCategory(id, count) {
            const filteredSubCategories = [ ...this.subcategories.filter( ( { id_cat } ) => {
                // Convertir ambos valores a string para comparación consistente
                const categoryId = String(id_cat);
                const selectedId = String(id);
                return categoryId === selectedId;
            } ) ];
            
            this.subcategoriesByCategory = filteredSubCategories.sort( this.sortByOrderItem );

            this.currentFilter.category = id;
            this.cleanPageFlags();
            count > 0 ? this.hasDetails = true : this.hasDetails = false;
            this.subCategoriesPage = true;
            this.loadElements();
        },
        sendElement( index ){
            this.validateOutOfInput(index)
            const { data, type, cantidad, id } = this.selectedElementsToShow[ index ];

            if( !this.selectedElementsToShow[ index ].hasError ) {
                data.qty = parseFloat(cantidad);
                this.$emit( "addElement", { data, type } );
                this.cancelQuantityManagement( index )
            } else {
                const target = document.getElementById( `tableinputnumber${type}${id}` )
                this.addShakeClass(target);
            }
        },
        addShakeClass( target ) {
            target.classList.add('shake');
            setTimeout(
                () => {
                    target.classList.remove('shake');
                },
                500
            )
        },
        clickSubCategory( id ) {
            this.currentFilter.subcategory = id;
            this.showElements = true;
            this.loadElements();
        },
        cleanPageFlags(){
            this.familiesPage = false;
            this.categoriesPage = false;
            this.subCategoriesPage = false;
            this.hasDetails = true;
        },
        goToPreviousPage(){
            if( this.showElements ) {
                // Si está mostrando productos/servicios, volver a subcategorías
                this.showElements = false;
                this.cleanPageFlags();
                if (this.currentFilter.subcategory) {
                    this.currentFilter.subcategory = null;
                    this.subCategoriesPage = true;
                } else if (this.currentFilter.category) {
                    this.currentFilter.subcategory = null;
                    this.currentFilter.category = null;
                    this.categoriesPage = true;
                } else {
                    this.currentFilter.subcategory = null;
                    this.currentFilter.category = null;
                    this.currentFilter.family = null;
                    this.familiesPage = true;
                }
                this.loadElements();
            } else if( this.subCategoriesPage ) {
                // Si está en subcategorías, volver a categorías
                this.cleanPageFlags();
                this.currentFilter.subcategory = null;
                this.currentFilter.category = null;
                this.categoriesPage = true;
                this.loadElements();
            } else if( this.categoriesPage ) {
                // Si está en categorías, volver a familias
                this.cleanPageFlags();
                this.familiesPage = true;
                this.currentFilter.subcategory = null;
                this.currentFilter.category = null;
                this.currentFilter.family = null;
                this.loadElements();
            }
        }
    }
}

</script>
<style scoped>
    .btndisable {
        background-color: #41464c !important;
        color: white;
    }
    
    .tableinputnumber {
        width: 75px;
        height: 40px;
        border: 1px solid rgb(17, 0, 255);
        border-radius: 7px;
        font-size: 25px;
        text-align: right;
        padding-right: 7px;
        background-color: rgb(241, 240, 240);
    }

    .erroredtableinputnumber {
        border: 1px solid rgb(245, 62, 62) !important;
    }
    .hideSpan {
        display: none;
    }

    .errorSpan {
        margin-left: 5%;
        margin-right: 5%;
    }

    .divErrorSpan {
        width: 50%;
        margin: 0 auto;
        width: 500px;
        border-radius: 7px;
        font-weight: bold;
        color: white;
        margin-bottom: 15px;
        background-color: rgb(245, 62, 62);
    }

    .buttonIcon{
        border-radius: 50%;
        margin-left: 15px;
        margin-right: 15px;
        margin-bottom: 10px;
        box-shadow: 0 4px rgb(142, 142, 224);
        background-color: rgb(86, 86, 199);
    }

    .buttonIcon:active {
        background-color: rgb(49, 49, 175);
        box-shadow: 0 0px rgb(96, 96, 187);
        transform: translateY(4px);
    }

    .buttonIcon:hover {
        background-color: rgb(49, 49, 175);
    }

    .quantityManagement{
        text-align: center;
        padding-bottom: 1.5%;
        border-radius: 0px 0px 25px 25px;
        background-color: #949699;
    }

    .quantityManagementDownPanel {
        text-align: center;
    }

    .leftSideDownPanelButton{
        margin-right: 10px;
    }
    .downPanelButtons {
        border-radius: 50%;
        margin-left: 15px;
        margin-right: 15px;
        margin-bottom: 10px;
        box-shadow: 0 4px rgb(172, 172, 172);
        background-color: #00A178;
    }
    
    .downPanelButtons:active {
        box-shadow: 0 0px rgb(172, 172, 172);
        transform: translateY(4px);
    }
    .downPanelButtons:hover {
        background-color: #027559;
    }
    .elementsList {
        overflow-x: scroll;
        min-width: 900px;
    }

    .elementPanel {
        border-radius: 15px 15px 0px 0px;
    }

    .elementPanel:active {
        background-color: rgb(241, 240, 240);
    }

    .shake {
        animation: shake 500ms infinite;
    }

    @keyframes shake {
        0% { transform: translateX(0); }
        5% { transform: translateX(-4px); }
        15% { transform: translateX(4px); }
        25% { transform: translateX(-4px); }
        35% { transform: translateX(4px); }
        45% { transform: translateX(-4px); }
        55% { transform: translateX(4px); }
        65% { transform: translateX(-4px); }
        75% { transform: translateX(3px); }
        85% { transform: translateX(-3px); }
        100% { transform: translateX(0); }
    }

    .closeQuantityManagementPanel {
        text-align: right;
        height: 20px;
    }

    .grid-card {
        border: 1px solid rgba(0, 0, 0, 0.1);
        border-radius: 4px;
        cursor: pointer;
        
    }
    
    .grid-card:hover {
        border: 1px solid rgba(21, 101, 192, 0.25);
        box-shadow: 2px 2px 5px rgba(21, 101, 192, 0.2);
    }
</style>